import React from "react";
import { SF009_SIG_H, SF009_SIG_W, isSigImage, toSigDataUrl } from "./sf009FormSignatureUtils";

export default function Sf009SignatureDisplay({ value, minHeight = SF009_SIG_H }) {
  const signed = value && typeof value === "object" ? value.signed : value;
  const text = signed != null ? String(signed).trim() : "";

  if (isSigImage(text)) {
    const url = toSigDataUrl(text);
    if (!url) {
      return <span style={{ color: "#a0aec0", fontSize: 11 }}>—</span>;
    }
    return (
      <img
        src={url}
        alt="Signature"
        style={{
          width: "100%",
          maxWidth: SF009_SIG_W,
          height: minHeight,
          objectFit: "contain",
          objectPosition: "center",
          display: "block",
          imageRendering: "auto",
        }}
        onError={(e) => {
          e.target.style.display = "none";
        }}
      />
    );
  }

  if (text) {
    return (
      <span style={{ fontSize: 12, fontWeight: 600, color: "#1a202c", lineHeight: 1.4, wordBreak: "break-word" }}>
        {text}
      </span>
    );
  }

  return <span style={{ color: "#a0aec0", fontSize: 11 }}>—</span>;
}
